<template>
  <div class="row">
    <form-searcher label="Token do odnalezienia" v-model="search" @submitAction="searchTranch()" dataTooltip="Szukaj transzy"
               buttonIcon="mfind-icon-search"/>

    <div>
      <a @click="clearSearch()" v-bind:class="buttonClose()">
        Anuluj wyszukanie
      </a>
    </div>
    <div class="error center-align" v-if="(isSearchDataExist===false) && search.length">
      <span class="red-text">Nie odnaleziono transzy spełniającej kryteria wyszukania</span>
    </div>

    <table class="responsive-table">
      <thead>
        <tr>
          <th>Token</th>
          <th>Wartość</th>
          <th>Email<br/>użytkownika</th>
          <th>Status</th>
          <th>Zmień status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="trancheItem in rows" :key="trancheItem.token">
          <td>{{ trancheItem.token }}</td>
          <td>{{ trancheItem.amount | currency }}</td>
          <td>{{ trancheItem.account.email }}</td>
          <td>{{ trancheItem.status }}</td>
          <td>
            <button class="btn" @click="openModal(trancheItem)">
              <i class="mfind-icon-edit"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <modal-tranche v-if="showModal" :showModal="showModal" :tranche="tranche" id="tranche-settings"
                   @close="showModal=!showModal" :currentStatus="trancheStatus" @reloadTranches="reloadTranches" />

    <ul class="pagination" v-if="selectPagination.total_pages > 1">
      <div class="btn-groups-pagination" v-bind:class="buttonHide(1)">
        <li class="btn btn-pagination waves-effect" type="button" @click="firstPage()"> &laquo; </li>
        <li class="btn btn-pagination waves-effect" type="button" @click="previousPage()"> &lsaquo; </li>
      </div>

      <li v-for="item in selectPagination.total_pages" @click="setPage(item)"
          v-bind:class="[(currentPage === item) ? 'active' : 'waves-effect']">
        <a>{{ item }}</a>
      </li>

      <div class="btn-groups-pagination" v-bind:class="buttonHide(selectPagination.total_pages)">
        <li class="btn btn-pagination waves-effect" type="button" @click="nextPage()"> &rsaquo; </li>
        <li class="btn btn-pagination waves-effect" type="button" @click="lastPage()"> &raquo; </li>
     </div>
    </ul>

    <Loader :loading="getTranchesPending" type=""/>
  </div>
</template>

<script>
import Loader from '@/components/loader'
import ModalTranche from '@/components/modalTranche'
import FormSearcher from '@/components/forms/searcher'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('tranches')
export default {
  components: { Loader, ModalTranche, FormSearcher },
  data () {
    return {
      search: '',
      currentPage: 1,
      items: false,
      tranche: false,
      showModal: false
    }
  },
  methods: {
    searchTranch () {
      this.$store.dispatch('tranches/findTranchesBy', { token: `"${this.search}"` })
      this.currentPage = 1
    },
    clearSearch () {
      this.$store.commit('tranches/CLEAR_SEARCH')
      this.search = ''
      this.firstPage()
    },
    setPage (pageNumber, reload = false) {
      if (!reload && (pageNumber === this.currentPage || pageNumber === null)) {
        return
      }

      if (!this.getSearchTranches.length) {
        this.$store.dispatch('tranches/getTranches', pageNumber)
      } else {
        this.$store.dispatch('tranches/findTranchesBy', { token: `"${this.search}"`, page: pageNumber })
      }
      this.currentPage = pageNumber
    },
    previousPage () {
      this.setPage(this.selectPagination.previous_page)
    },
    nextPage () {
      this.setPage(this.selectPagination.next_page)
    },
    firstPage () {
      this.setPage(1)
    },
    lastPage () {
      this.setPage(this.selectPagination.total_pages)
    },
    buttonHide (pageNumber) {
      return [ this.currentPage === pageNumber ? 'btn-hide' : 'btn-show' ]
    },
    buttonClose () {
      return [ this.search.length ? 'btn-show' : 'btn-hide' ]
    },
    currentStatusVal (status) {
      for (let item of this.getStatuses) {
        if (item.name === status) {
          return item.value
        }
      }
    },
    openModal (tranche) {
      this.showModal = true
      this.tranche = tranche
      this.trancheStatus = this.currentStatusVal(tranche.status)
    },
    reloadTranches () {
      this.setPage(this.currentPage, true)
    }
  },
  created () {
    this.$store.dispatch('tranches/getTranches')
    this.$store.dispatch('tranches/getStatuses')
  },
  computed: {
    // mix the getters into the computed object
    ...mapGetters([
      'getTranches', 'getStatuses', 'getTranchesPending', 'getSearchTranches', 'getPagination', 'getSearchPagination',
      'isSearchDataExist'
    ]),
    rows () {
      return this.getSearchTranches.length ? this.getSearchTranches : this.getTranches
    },
    selectPagination () {
      return this.getSearchTranches.length ? this.getSearchPagination : this.getPagination
    }
  }
}
</script>

<style lang="scss">
.pagination {
  text-align: center;

  .btn-groups-pagination {
    display: inline-block;
  }

  .btn-pagination {
    font-size: 17pt;
    line-height: 20pt;
    width: 2.3rem;
    padding: 0;
  }
}

.btn-close {
  background-color: #ffc107;
  margin-top: 1rem;
  height: 3.4rem;
  width: 3.4rem;
  padding: 0.6rem 0;
}

.btn-hide {
  opacity: 0;
  transition-timing-function: ease-in;
  transition: 0.3s;
  cursor: default;

  .btn-pagination {
    cursor: default;
  }
}

.btn-show {
  opacity: 1;
  transition-timing-function: ease-out;
  transition: 1s;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// listTranches.vue?2cf8df46